import { createFileRoute } from '@tanstack/react-router'

import { EventsAddForm } from '@/learnpaths-media-events-summary/components/EventsAddForm/EventsAddForm'

export const Route = createFileRoute('/company/_management/events/add/')({
  component: EventsAddForm,
})
